module.exports = new __parcel__URL__("FRAXLogo.493412e4.svg").toString();